/**
 * フォーム関係-グリッドの削除ボタン
 */
import React, { useCallback } from "react";

import { makeStyles, IconButton } from "@material-ui/core";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";

import { TRequiredKey } from "../../../common/components/types";

import formStore from "../../../../store/formStore";

const useStyles = makeStyles({
  minusIcon: {
    fontSize: "1.5em",
    marginLeft: 2,
    marginTop: 4,
  },
  iconButton: {
    padding: 0,
    float: "left",
  },
});

type Props = {
  formGroupNameId: number;
  terminalGridId: number;
  gridId: number;
  requiredKey: TRequiredKey;
};

const GridMinusButton: React.FC<Props> = (props: Props) => {
  const { formGroupNameId, terminalGridId, gridId, requiredKey } = props;

  const classes = useStyles();

  const handleClick = useCallback(() => {
    formStore.gridMinus(formGroupNameId, terminalGridId, gridId, requiredKey);
  }, [formGroupNameId, terminalGridId, gridId, requiredKey]);

  return (
    <IconButton
      color="primary"
      className={classes.iconButton}
      onClick={handleClick}
    >
      <IndeterminateCheckBoxIcon className={classes.minusIcon} />
    </IconButton>
  );
};

export default GridMinusButton;
